const augment8Dashboard = 'dashboard';
const performanceDashboard = 'performance_dashboard';
const login = 'login';
const error = 'error';
const payout = 'payout';
const payoutInitialization = 'payout_initialization';
const inputFileUpload = 'input_file_upload';
const fileManagement = 'file_management';
const masterFileUpload = 'master_file_upload';
const masterDataSourceConnections = 'master_data_source_connections';
const maintainence = 'maintainence';
const inputFileDownload = 'input_file_download';
const masterFileDownload = 'master_file_download';
const myTask = 'my_task';
const unificationHistory = 'unification_history';
const payoutHistory = 'payout_history';
const profile = 'profile';
const accounting = 'accounting';
const dashboardMapping = 'dashboard_mapping';
const chartMapping = 'chart_mapping';
const dashboardChartMapping = 'dashboard_chart_mapping';
const chart = 'chart';
const unifiedSourceMaster = 'unified_source_master';
const overview = 'overview';
const rulePlans = 'rule_plan';
const simulation = 'simulation';
const runSimulation = 'run_simulation';
const viewSimulation = 'view_simulation';
const ruleDetails = 'rule_details';
const syncManagement = 'sync_management';
const syncHistory = 'sync_history';
const dataSync = 'data_sync';
const teamLeadDashboard = 'teamlead_dashboard';
const targetSetting = 'target_setting';
const userDetails = 'user_details';
const incentiveProgram = 'incentive_program';
const historialReport = 'historial_report';
const userPerformanceReport = 'user_performance_report';
// const targetOverride = 'target_override';
const targetOverride = 'overridden_target';
const cancellationManagement = 'cancellation_management';
const contractCancellationUpload = 'contract_cancellation_upload';
const needToPay = 'need_to_pay';
const uploadUtr = 'upload_utr';
const payoutAdmin = 'payout_admin';
const reports = 'reports';
const payoutReport = 'payout_report';
const noDuesCertificate = 'no_dues_certificate';
const cashAndCoupons = 'cash_and_coupons';
const couponConfirmation = 'coupon_confirmation';
const holdRelease = 'hold_release';
const hold = 'hold';
const release = 'release';
const holdReleaseTaskConfig = 'hold_release_task_config';
const taskConfiguration = 'task_config';
const contest = 'contest';
const contestInitialization = 'contest_initialization';
const contestHistory = 'contest_history';
const dataCorrection = 'data_correction';
const inputFileDataCorrection = 'transaction_source_data_correction';
const masterFileDataCorrection = 'master_source_data_correction';
const triggerClawback = 'trigger_clawback';
const recalculationQuery = 'recalculation_query';

const resourceName = {
  simulation,
  runSimulation,
  viewSimulation,
  augment8Dashboard,
  performanceDashboard,
  login,
  error,
  payoutInitialization,
  payout,
  inputFileUpload,
  fileManagement,
  masterFileUpload,
  masterDataSourceConnections,
  maintainence,
  inputFileDownload,
  masterFileDownload,
  myTask,
  unificationHistory,
  payoutHistory,
  profile,
  accounting,
  dashboardMapping,
  chartMapping,
  dashboardChartMapping,
  chart,
  unifiedSourceMaster,
  overview,
  rulePlans,
  ruleDetails,
  syncManagement,
  dataSync,
  syncHistory,
  teamLeadDashboard,
  targetSetting,
  userDetails,
  incentiveProgram,
  historialReport,
  userPerformanceReport,
  targetOverride,
  contractCancellationUpload,
  cancellationManagement,
  needToPay,
  uploadUtr,
  payoutAdmin,
  reports,
  payoutReport,
  noDuesCertificate,
  cashAndCoupons,
  couponConfirmation,
  holdRelease,
  hold,
  release,
  holdReleaseTaskConfig,
  taskConfiguration,
  contest,
  contestInitialization,
  contestHistory,
  dataCorrection,
  inputFileDataCorrection,
  masterFileDataCorrection,
  triggerClawback,
  recalculationQuery,
};

export default resourceName;
